import { makeStyles } from '@material-ui/core/styles';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { color } from './app/theme';
import Loading from './components/Loading';
import Header from './components/aiBot/Header';
import Initial from './components/aiBot/Initial';
import ProgressContainer from './components/aiBot/ProgressContainer';
import SocketioLayer from './components/aiBot/SocketioLayer';
import AdvanceSettingContainer from './components/aiBot/advanceSetting/Container';
import BasicSettingContainer from './components/aiBot/basicSetting/Container';
import KnowledgeContainer from './components/aiBot/knowledge/Container';
import AddFileContainer from './components/aiBot/knowledge/addFile/Container';
import AddWebContainer from './components/aiBot/knowledge/addWeb/Container';
import SidebarContainer from './components/aiBot/sidebar/SidebarContainer';
import TestingContainer from './components/aiBot/testing/Container';
import TriggerSettingContainer from './components/aiBot/triggerSetting/Container';

const useStyles = makeStyles(
  () => ({
    root: {
      height: 'calc(100vh - 80px)',
    },
    main: {
      width: 'calc(100% - 240px)',
      height: 'calc(100vh - 80px)',
      backgroundColor: color.$7,
      padding: '44px 44px 96px 44px',
      margin: '80px 320px 0 240px',
      overflow: 'auto',
    },
    noSidebar: {
      width: '100%',
      height: 'calc(100vh - 80px)',
      backgroundColor: color.$7,
      padding: '44px 44px 96px 44px',
      margin: '80px 0 0 0',
      overflow: 'auto',
    },
    loading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100vh',
    },
  }),
  {
    name: 'AiBotRoute',
  },
);

function AiBotRoute() {
  const classes = useStyles();
  const { progress, pathKey } = useSelector(store => store.aiBot);
  const [isloading, setIsloading] = useState(false);
  const mainRef = useRef(null);

  return (
    <Switch>
      <Route path="/aiBot">
        <Route path="/aiBot/:orgId/:id">
          <Initial setIsloading={setIsloading} />
          <SocketioLayer />
          {isloading ? (
            <Loading />
          ) : (
            <div className={classes.root}>
              <Header pathKey={pathKey} />
              <SidebarContainer pathKey={pathKey} />
              <Switch>
                <Route exact path="/aiBot/:orgId/:id/knowledge/addWeb">
                  <main
                    ref={mainRef}
                    id="App-main"
                    className={classes.main}
                    style={{ marginTop: 80, paddingBottom: 0 }}
                  >
                    <AddWebContainer mainRef={mainRef} pathKey={pathKey} />
                  </main>
                </Route>
                <Route exact path="/aiBot/:orgId/:id/knowledge/addFile">
                  <main
                    ref={mainRef}
                    id="App-main"
                    className={classes.main}
                    style={{ marginTop: 80, paddingBottom: 0 }}
                  >
                    <AddFileContainer mainRef={mainRef} pathKey={pathKey} />
                  </main>
                </Route>
                <Route exact path="/aiBot/:orgId/:id/knowledge">
                  <main
                    ref={mainRef}
                    id="App-main"
                    className={classes.main}
                    style={{ marginTop: progress?.done ? 80 : 188 }}
                  >
                    <ProgressContainer pathKey={pathKey} />
                    <KnowledgeContainer mainRef={mainRef} pathKey={pathKey} />
                  </main>
                </Route>
                <Route exact path="/aiBot/:orgId/:id/basicSetting">
                  <main
                    id="App-main"
                    className={classes.main}
                    style={{ marginTop: progress?.done ? 80 : 188 }}
                  >
                    <ProgressContainer pathKey={pathKey} />
                    <BasicSettingContainer pathKey={pathKey} />
                  </main>
                </Route>
                <Route exact path="/aiBot/:orgId/:id/triggerSetting">
                  <main
                    id="App-main"
                    className={classes.main}
                    style={{ marginTop: progress?.done ? 80 : 188 }}
                  >
                    <ProgressContainer pathKey={pathKey} />
                    <TriggerSettingContainer pathKey={pathKey} />
                  </main>
                </Route>
                <Route exact path="/aiBot/:orgId/:id/advanceSetting">
                  <main
                    id="App-main"
                    className={classes.main}
                    style={{ marginTop: progress?.done ? 80 : 188 }}
                  >
                    <ProgressContainer pathKey={pathKey} />
                    <AdvanceSettingContainer pathKey={pathKey} />
                  </main>
                </Route>
                <Route exact path="/aiBot/:orgId/:id/testing">
                  <main
                    id="App-main"
                    className={classes.main}
                    style={{ padding: 44 }}
                  >
                    <TestingContainer pathKey={pathKey} />
                  </main>
                </Route>
              </Switch>
            </div>
          )}
        </Route>
      </Route>
    </Switch>
  );
}

export default AiBotRoute;
